import { render } from "./IndexCaisse.vue?vue&type=template&id=13a2dab3"
import script from "./IndexCaisse.vue?vue&type=script&lang=js"
export * from "./IndexCaisse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__